<template>
  <div class="banner">
    <a
      :href="link"
      target="_blank"
      rel="noopener"
      class="banner__link"
    >
      <img
        :src="url"
        alt=""
        class="banner__img"
      >
    </a>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Banner',
  props: {
    id: String,
  },
  data() {
    return {
      baseUrl: 'https://mkt.russiarunning.com/api/v1',
			uuid: this.createUUID(),
    };
  },
  computed: {
    device() {
      if (window.innerWidth < 768) {
        return 'mobile';
      }
      return 'desktop';
    },
    url() {
      return `${this.baseUrl}/${this.id}/${this.uuid}_${this.device}.jpg`;
    },
    link() {
      return `${this.baseUrl}/${this.id}/${this.uuid}_${this.device}.lnk`;
    }
  },
  methods: {
    createUUID() {
      let dt = new Date().getTime();
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
        (c) => {
          // eslint-disable-next-line no-bitwise
          const r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          // eslint-disable-next-line no-mixed-operators,no-bitwise
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  &__link {
    display: block;
    width: 100%;
    text-decoration: none;
  }

  .banner__img {
    display: block;
    width: 100%;
  }
}
</style>
